import { Radio } from "antd";
import ArmorCodeGroupField from "components/ArmorCodeGroupField";
import { ProductsAndSubProductsFilter } from "components/ProductsAndSubProductsFilter";
import Vocabulary from "components/Vocabulary";
import { ProductsAndSubProductsFilterProvider } from "contexts/ProductsAndSubProductsFilterContext";
import React, { forwardRef, useCallback } from "react";

export const ACCESS_TYPE_GROUPS = "group",
  ACCESS_TYPE_INDIVIDUAL = "individual";

export default function TeamProductSubProductAccessField({
  productSubProductFieldRef,
  field,
  productAndSubProductChange,
  onAccessTypeChange,
  onGroupSelect,
}) {
  const { accessType, disabled, groups, ...restFieldProps } = field;
  const productSubproductFieldProps = {
    ...restFieldProps,
    ref: productSubProductFieldRef,
    afterChange: productAndSubProductChange,
    disabled,
  };

  const _onAccessTypeChange = useCallback(
    (e) => {
      onAccessTypeChange(e.target.value, field.name);
    },
    [onAccessTypeChange, field.name]
  );

  const _onGroupSelect = useCallback(
    (groups) => {
      onGroupSelect(groups, field.name);
    },
    [onGroupSelect, field.name]
  );

  return (
    <div>
      <div>
        <span className="text-bold">Select</span>
        <Radio.Group
          defaultValue={ACCESS_TYPE_INDIVIDUAL}
          disabled={disabled}
          className="m-l-xs"
          onChange={_onAccessTypeChange}
          value={accessType}
        >
          <Radio value={ACCESS_TYPE_GROUPS}><Vocabulary name= "group"/>(s)</Radio>
          <Radio value={ACCESS_TYPE_INDIVIDUAL}>
            <Vocabulary name="product" isPlural={true} /> /{" "}
            <Vocabulary name="subProduct" isPlural={true} />
          </Radio>
        </Radio.Group>
      </div>
      {accessType === ACCESS_TYPE_GROUPS ? (
        <ArmorCodeGroupField
          disabled={disabled}
          value={groups}
          onChange={_onGroupSelect}
        />
      ) : (
        <ProductsAndSubProductsFilterProvider useFilterdAPI={true}>
          <ProductsAndSubProductsFilter {...productSubproductFieldProps} />
        </ProductsAndSubProductsFilterProvider>
      )}
    </div>
  );
};
